var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagrams = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.692 15.298a1.042 1.042 0 1 1-2.084 0 1.042 1.042 0 0 1 2.084 0ZM29 20v.013l-.06 3.776a5.21 5.21 0 0 1-5.15 5.151L20 29h-.013l-3.776-.06a5.212 5.212 0 0 1-5.152-5.15L11 20v-.013l.06-3.776a5.21 5.21 0 0 1 5.15-5.152L20 11h.013l3.776.06a5.21 5.21 0 0 1 5.151 5.15L29 20Zm-1.676 0-.06-3.763a3.542 3.542 0 0 0-3.501-3.502L20 12.676l-3.763.06a3.542 3.542 0 0 0-3.502 3.501L12.676 20l.059 3.763a3.542 3.542 0 0 0 3.502 3.502l3.763.059 3.763-.06a3.542 3.542 0 0 0 3.502-3.501L27.324 20Zm-2.702 0a4.621 4.621 0 1 1-9.243 0 4.621 4.621 0 0 1 9.243 0Zm-1.676 0a2.947 2.947 0 1 0-5.894 0 2.947 2.947 0 0 0 5.894 0Z",
  fill: "#fff"
})));
export default SvgInstagrams;